/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Storypage_Meta_DescInputs */

const en_fw_storypage_meta_desc = /** @type {(inputs: Fw_Storypage_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Firefly Wedding story without big spoilers: the premise, key story beats, the Meiji-era setting, the manga volumes and the anime’s staff.`)
};

const zh_fw_storypage_meta_desc = /** @type {(inputs: Fw_Storypage_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不剧透关键情节的萤火之嫁剧情介绍：故事设定、主要剧情节点、明治时代背景、漫画卷数与动画制作阵容。`)
};

/**
* | output |
* | --- |
* | "The Firefly Wedding story without big spoilers: the premise, key story beats, the Meiji-era setting, the manga volumes and the anime’s staff." |
*
* @param {Fw_Storypage_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_storypage_meta_desc = /** @type {((inputs?: Fw_Storypage_Meta_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Storypage_Meta_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_storypage_meta_desc(inputs)
	return zh_fw_storypage_meta_desc(inputs)
});
export { fw_storypage_meta_desc as "fw.storypage.meta_desc" }